var polymorphic = /*#__PURE__*/Object.freeze({
  __proto__: null
});

export { polymorphic as p };
